export default {"src":"/trader-new/_next/static/media/bell.9938b8d6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};